import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import api from "../../api";
import "./login.css";

import { useTheme } from "../../components/header/header";
import Input from "../../components/input/input";
import Button from "../../components/button/button";

import logo from "./img/logo.svg";
import logoDark from "./img/logo-dark.svg";
import image1 from "./img/img.png";

const LogIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [saveLogin, setSaveLogin] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const { theme } = useTheme();

  const navigate = useNavigate();

  const validateEmail = (val) => {
    const emailPattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i;
    if (!emailPattern.test(val)) {
      return "Please enter a valid email address.";
    }
    return null;
  };

  const validatePassword = (val) => {
    if (val.length < 6) {
      return "Password must be at least 6 characters long.";
    }
    return null;
  };

  React.useEffect(() => {
    const savedEmail = localStorage.getItem("savedEmail");
    const savedPassword = localStorage.getItem("savedPassword");

    if (savedEmail && savedPassword) {
      setEmail(savedEmail);
      setPassword(savedPassword);
      setSaveLogin(true);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    let isValid = true;

    if (validateEmail(email)) {
      isValid = false;
    }
    if (validatePassword(password)) {
      isValid = false;
    }

    if (!isValid) {
      setError("Something went wrong");
      return;
    }

    setError(null);
    setLoading(true);

    try {
      const response = await api.post("/api/login", {
        email,
        password,
        recaptcha: null,
      });

      const { token, user_id } = response.data;
      localStorage.setItem("token", token);
      localStorage.setItem("user_id", user_id);

      if (saveLogin) {
        localStorage.setItem("savedEmail", email);
        localStorage.setItem("savedPassword", password);
      } else {
        localStorage.removeItem("savedEmail");
        localStorage.removeItem("savedPassword");
      }

      navigate("/deposit");
    } catch (err) {
      if (err.response && err.response.status === 401) {
        setError("Invalid email or password.");
      } else {
        setError("An error occurred. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  const isButtonDisabled = !email || !password || loading;

  return (
    <div className="container">
      <div>
        <div className="logoWrap">
          <img src={theme === "light" ? logo : logoDark} alt="logo" />
        </div>
        <div className="imgWrap">
          <img className="img" src={image1} alt="img" />
        </div>
        <h1 className="title">Log In</h1>
        <form>
          {/* <Input
            label="Email address"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Input
            label="Password"
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          /> */}
          <Input
            label="Email address"
            id="email"
            type="email"
            value={email}
            onChange={(val) => setEmail(val)}
            validate={(val) => validateEmail(val)}
          />
          <Input
            label="Password"
            id="password"
            type="password"
            value={password}
            onChange={(val) => setPassword(val)}
            validate={(val) => validatePassword(val)}
          />
          <div className="lineWrap">
            <div
              className={`custom-checkbox ${theme === "dark" ? "dark" : ""}`}
            >
              <input
                type="checkbox"
                id="save-login"
                checked={saveLogin}
                onChange={(e) => setSaveLogin(e.target.checked)}
              />
              <label className="saveLabel" htmlFor="save-login">
                Save login
              </label>
            </div>
            <div>
              <a href="/">Forgot password?</a>
            </div>
          </div>
          <Button
            type="submit"
            text="Log In"
            onClick={handleSubmit}
            disabled={isButtonDisabled}
            loading={loading}
          />
          {error && <div className="error">{error}</div>}
        </form>
        <div className="bottomText">
          Don’t have an account?{" "}
          <Link className="bottomTextLink" to="/register">
            Register
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LogIn;
